import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsAlphanumeric, IsOptional, IsNumber } from "class-validator";

export class ContractRequest{

    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    contractorId: number;

    @ApiProperty()
    @IsOptional()
    updatedUser: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag: number;

    @ApiProperty()
    isActive: boolean;
}